import type { SVGProps } from "react";
export interface SwimmingIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SwimmingIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SwimmingIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.691 18.884a1.77 1.77 0 0 1 1.95 0l.123.089.196.15c.46.333 1.129.696 1.868.746l.172.006.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006-.314-.01c-1.306-.085-2.371-.687-3.02-1.153-.701.503-1.885 1.163-3.333 1.163s-2.634-.66-3.334-1.163c-.7.503-1.885 1.163-3.333 1.163s-2.633-.66-3.333-1.163c-.701.503-1.885 1.163-3.333 1.163a1.125 1.125 0 0 1 0-2.25c.923 0 1.755-.514 2.237-.902l.121-.09a1.77 1.77 0 0 1 1.95 0l.122.09.197.15c.495.359 1.233.752 2.04.752.922 0 1.755-.514 2.236-.902l.122-.09a1.77 1.77 0 0 1 1.95 0l.121.09.198.15c.494.359 1.232.752 2.039.752.923 0 1.755-.514 2.237-.902l.121-.09Zm0-4a1.77 1.77 0 0 1 1.95 0l.123.09.196.15c.46.332 1.129.695 1.868.745l.172.006.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006-.314-.01c-1.305-.086-2.371-.686-3.02-1.152-.701.503-1.886 1.162-3.333 1.162s-2.634-.66-3.334-1.162c-.7.503-1.885 1.162-3.333 1.162s-2.633-.66-3.333-1.162c-.701.503-1.885 1.162-3.333 1.162a1.125 1.125 0 0 1 0-2.25c.923 0 1.755-.513 2.237-.901l.121-.09a1.77 1.77 0 0 1 1.95 0l.122.09.197.15c.495.357 1.233.75 2.04.75.922 0 1.755-.512 2.236-.9l.122-.09a1.77 1.77 0 0 1 1.95 0l.121.09.198.15c.494.357 1.232.75 2.039.75.922 0 1.755-.512 2.237-.9zm-7.949-1.257a1.125 1.125 0 0 1-1.67-1.507zm-2.83-7.503a7.13 7.13 0 0 1 6.952 1.166c.471.385.942.836 1.327 1.182l.362.34q.53.521.986 1.107l.306.416q.295.423.548.86l.243.441.048.104a1.125 1.125 0 0 1-1.978 1.05l-.058-.1-.136-.245-.5.558-1.673-1.505.81-.903q-.085-.09-.174-.179l-.288-.271q-.235-.212-.443-.404l-3.502 3.886-1.67-1.507 3.353-3.721a4.87 4.87 0 0 0-4.058-.032L5.062 9.402a1.126 1.126 0 0 1-.923-2.052l2.305-1.036zm8.1 6.879a1.126 1.126 0 0 1-1.673-1.505zm3.863-7.253a.626.626 0 1 0-1.252.001.626.626 0 0 0 1.252 0Zm2.25 0a2.875 2.875 0 1 1-5.75-.001 2.875 2.875 0 0 1 5.75.001"
      />
    </svg>
  );
}
